import noUiSlider from 'nouislider';

const ranges = document.querySelectorAll('.js-range-apartaments');
const param = '.js-param-apartaments';

ranges.forEach((range) => {
	let { typePips } = range.dataset;
	const { inputMin, inputMax, inputStart, inputStop } = range.dataset;
	if (typePips) {
		typePips = {
			mode: 'count',
			values: 4,
			density: false,
			stepped: true,
		};
	}

	noUiSlider.create(range, {
		start: [inputStart || inputMin, inputStop || inputMax],
		connect: true,
		range: {
			min: parseFloat(inputMin),
			max: parseFloat(inputMax),
		},
		step: 1,
		decimals: 0,
		pips: typePips,
	});

	const rangeDiv = range.closest(param);
	const inputs = [rangeDiv.querySelector('.js-range-min'), rangeDiv.querySelector('.js-range-max')];

	range.noUiSlider.on('update', (values, handle) => {
		inputs[handle].value = parseFloat(values[handle]);
	});

	inputs.forEach((input, handle) => {
		input.addEventListener('change', () => {
			range.noUiSlider.setHandle(handle, input.value);
		});

		input.addEventListener('click', () => {
			input.select();
		});
	});
});
